import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { PATHS } from 'src/common/constants';
import Typography from 'src/common/components/Typography';
import Icon from 'src/common/components/IconDS22';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import styles from './CookieContent.module.scss';
import Button from '../ButtonDS22';
import UniversalLink from '../UniversalLink';

export type CookieContentProps = {
  onClose: () => void;
};

const CookieContent: FC<CookieContentProps> = ({ onClose }) => {
  const [t] = useTranslation('common');
  const { isMobileNativeWebView } = useMobileNativeWebView();

  if (isMobileNativeWebView) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <div className={styles.icon}>
          <Icon
            id="cookie"
            size="xl"
          />
        </div>
        <Typography
          size="heading-5"
          sizeFromBreakpointM="body-xl"
          weight="semibold"
          type="h3"
        >
          {t('cookie-banner-message-0')}
        </Typography>
      </div>
      <div className={styles.content}>
        <div className={styles.description}>
          <Typography
            size="body-l"
            weight="regular"
            type="p"
          >
            <Trans
              t={t}
              i18nKey="cookie-banner-message-1"
              components={[
                <UniversalLink href={PATHS.TERMS} />,
                <UniversalLink href={PATHS.PRIVACY_POLICY} />,
              ]}
            />
          </Typography>
        </div>
        <Button
          variant="tertiary"
          onClick={onClose}
          fitWidth="m"
        >
          {t('cookie-banner-close')}
        </Button>
      </div>
    </div>
  );
};

export default CookieContent;
